import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'ph.layers';
const DEFAULT_LAYERS = { sharedPlaces: true, hunted: true, duplicates: false };

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_LAYERS;
    return { ...DEFAULT_LAYERS, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_LAYERS;
  }
}

export function useGridLayers() {
  const [layers, setLayers] = useState(readStored);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(layers));
    } catch {
      // ignore write failures (private browsing, storage full, etc.)
    }
  }, [layers]);

  const toggleLayer = useCallback((key) => {
    setLayers(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);

  return { layers, toggleLayer };
}
